import { Component, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { AuthProvider } from "../../providers/auth/auth";
import { HomePage } from '../home/home';
import { WebloginPage } from '../weblogin/weblogin';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HomePage_PATH, WebloginPage_PATH } from '../../app/app-constants';
/**
 * Generated class for the ApploginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-applogin',
  templateUrl: 'applogin.html',
  styleUrls: ['./applogin.scss'],
  standalone: false,
  imports: [
    IonicModule,
    TranslateModule,
    CommonModule,
    FormsModule
  ]
})
export class ApploginPage implements OnInit {
  public static PATH: string = 'applogin';

  constructor(
    public router: Router,
    private auth: AuthProvider
  ) { }

  ngOnInit() {
    console.log('ApploginPage: calling ngOnInit');
    //this.aws.load();
  }

  loginCallback() {
    console.log('AppLoginPage: going to home page');
    this.router.navigate([ HomePage_PATH ]);
  }
  glogin() {
    console.log('ApploginPage: calling glogin');
    this.auth.glogin(this);
  }

  glogout() {
    console.log('ApploginPage: calling glogout');
    this.auth.glogout();
  }

  fblogin() {
    console.log('ApploginPage: calling fblogin');
    this.auth.fblogin(this);
  }
  fblogout() {
    console.log('ApploginPage: calling fblogout');
    this.auth.fblogout();
  }

  emailpwdlogin() {
    console.log('ApploginPage: routing to ' + WebloginPage_PATH);
    this.router.navigate([ WebloginPage_PATH ]);
  }
}
